import Endpoint from './Endpoint.jsx';
import './Endpoint.scss';

export default Endpoint;
